<template>
  <div class="reel flex overflow-hidden flex-col xm:flex-row" v-if="isLoaded">
    <PublishedReelPlayer :video="video" :autoplay="autoplay" />

    <div v-if="showClipList" class="reel-right relative">
      <PublishedClipList />
    </div>
  </div>

  <div v-else class="flex justify-center items-center">
    <Spinner/>
  </div>
</template>

<script>
import PublishedReelPlayer from './PublishedReelPlayer'
import PublishedClipList from './PublishedClipList'
import Spinner from '@/components/Spinner'
import {mapActions, mapGetters} from 'vuex'

export default {
  components: {
    PublishedReelPlayer,
    PublishedClipList,
    Spinner,
  },

  props: {
    projectId: {required: true},
    showClipList: {type: Boolean, default: true},
    autoplay: {type: Boolean, default: false},
    video: {type: Object, require: true},
  },

  computed: {
    ...mapGetters("publishedReelPlayer", [
      'isLoaded',
      'clipsInPlayOrder',
    ]),
  },

  created() {
    this.loadProject(this.projectId)
  },

  beforeDestroy() {
    this.resetState()
  },

  methods: {
    ...mapActions("publishedReelPlayer", [
      'loadProject',
      'resetState',
      'jumpToClip',
    ])
  }
}
</script>

<style lang="scss" scoped>
  .reel-right {
    flex-basis: 33%;
    // @media screen and (min-width: 768px) { flex-basis: 30% }
    // @media screen and (min-width: 992px) { flex-basis: 33% }
    // @media screen and (min-width: 1200px) { flex-basis: 25% }
  }
</style>